import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import "../blocks/App.css";

import Header from "./Header";
import Footer from "./Footer";
import PageContent from "./PageContent";
import PrivacyPolicy from "./PrivacyPolicy";
import BlogPost from "./BlogPost";
import FetchPosts from "./FetchPosts";

import { inject } from "@vercel/analytics";

function App() {
  useEffect(() => {
    inject();
  }, []);
  return (
    <Router>
      <ScrollToTop />
      <div className="page">
        <div className="page__content">
          <Header />
          <Routes>
            <Route path="/" element={<PageContent />} />
            <Route path="/sobre-nosotros" element={<Navigate to="/#equipo" replace />} />
            <Route path="/entrenadores-personales" element={<Navigate to="/#equipo" replace />} />
            <Route path="/reserva-una-sesion-de-prueba" element={<Navigate to="/" replace />} />
            <Route path="/juancarlos" element={<Navigate to="/#equipo" replace />} />
            <Route path="/xavilift" element={<Navigate to="/#equipo" replace />} />
            <Route path="/instalaciones" element={<Navigate to="/#centro" replace />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/blog" element={<FetchPosts />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Routes>
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;
